// extracted by mini-css-extract-plugin
export var linkText = "_nu-0";